module.exports = __webpack_public_path__ + "17126c22f8a08b3f9a9b1fee92a59d05.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/trenchcoat.png
// module id = 1957
// module chunks = 0